<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item,i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px;"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="客户选择：" class="width100" style="display: inline-block;">
              <el-select v-model="tableFrom.custom_id" @change="getList" placeholder="请选择" style="width: 200px" >
                <el-option
                  v-for="(i,indx) in clientList"
                  :key="i.custom_id"
                  :label="i.custom_name"
                  :value="i.custom_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态：" class="width100" style="display: inline-block;">
              <el-select v-model="tableFrom.status" @change="getList" placeholder="请选择" style="width: 200px" >
                <el-option
                  v-for="(i,indx) in statusList"
                  :key="i.status"
                  :label="i.statusTxt"
                  :value="i.status"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/sku/备注"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
        row-key="recovery_category_id"
        lazy
        height="600"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          label="ID"
          min-width="50"
          prop="out_stock_order_id"
          expand-row-keys="custom_name"/>
        <el-table-column
          label="生成时间"
          min-width="150"
          prop="create_time"
          expand-row-keys="custom_name"/>
        <el-table-column
          label="客户名称"
          min-width="100"
          prop="custom_name"
          expand-row-keys="custom_name"/>
        <el-table-column
          label="客户电话"
          prop="custom_contact"
          min-width="100" />
        <el-table-column
          label="出库数量"
          prop="out_num"
          min-width="100" >
          <template slot-scope="scope">
            <span>{{scope.row.out_num||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="出单备注"
          prop="out_remark"
          min-width="100" >
          <template slot-scope="scope">
            <div v-if="remarkFn(scope.row.out_remark).length">
              <p v-for="(v,i) in remarkFn(scope.row.out_remark)">{{v}}</p>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预估金额"
          prop="out_price"
          min-width="100" />
        <el-table-column
          label="实际出库金额"
          prop="real_price"
          min-width="100" >
          <template slot-scope="scope">
            <span>{{scope.row.real_price||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="实际出库数量"
          prop="end_num"
          min-width="100" />
        <el-table-column
          label="实际出库备注"
          prop="end_remark"
          min-width="100">

        <template slot-scope="scope">
          <span>{{scope.row.end_remark||'--'}}</span>
        </template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          prop="end_time"
          min-width="120">
          <template slot-scope="scope">
            <span>{{scope.row.end_time||'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button  size="small" :type="scope.row.status==0?'primary':'success'"  @click="stashFn(scope.row)">{{ scope.row.status == 0?'立即结算':'结算详情'}}</el-button>
            <el-button  size="small"  @click="deleteShowFn(scope.row)">删 除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[15, 30]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableFrom.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>

    </el-card>
    <el-dialog
      :visible.sync="stashShow"
      width="95%"
      top="20px"
      :before-close="stashClose">
      <div style="display:flex;" class="detail"  v-loading="loadShow">
        <div style="height: 800px;overflow: auto;width: 40%">
          <span style="font-weight: bold;font-size: 18px">出库详情：</span>
          <div style="display:flex;flex-direction: column;flex-wrap: wrap;margin-top: 20px">
            <div style="margin: 2px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);padding:0 20px;height: 38px;display: flex;align-items: center" v-for="(item,index) in  detailData.out_product">
              <div style="display: flex;align-items: center">
                <span class="font16" style="width: 350px;">{{item.category_name}} {{item.sku}}</span>
                <span class="font16" style="margin-left: 20px;">出库数量：</span>
                <span class="font16" style="font-size: 16px;font-weight: bold;color: red">
                  x{{item.recoveryNum}}
                </span>
                <span class="font16" style="margin-left: 20px;" v-if="item.worn_two_num">出库异常数量：</span>
                <span class="font16" style="font-size: 16px;font-weight: bold;color: red" v-if="item.worn_two_num">
                  x{{item.worn_two_num}}
                </span>
              </div>
              <div style="display: flex;flex-direction: column" v-if="item.batch_list.length">
                <div v-for="(item1,index1) in item.batch_list" style="margin-top:10px;display: flex;align-items: center">
                  <span class="font16">批号：{{item1.batch_number}}</span>
                  <span class="font16" style="margin-left: 20px;">批号数量：</span>
                  <span class="font16" style="font-size: 18px;font-weight: bold;color: red">x{{item1.batch_num}}</span>
                </div>
              </div>
            </div>
          </div>

          <el-form ref="form" label-width="100px" style="margin-top: 20px">
            <el-form-item label="订单号:" >
              <span class="font16">{{detailData.out_stock_num}}</span>
            </el-form-item>
            <el-form-item label="开单时间:" >
              <span class="font16" style="margin-right: 10px">{{detailData.create_time}}</span>
            </el-form-item>
            <el-form-item label="出库备注:" >
              <span class="font16" style="margin-right: 10px" v-for="(v,i) in remarkFn(detailData.out_remark)">{{v}}</span>
            </el-form-item>
            <el-form-item label="客户名字:" >
              <span class="font16">{{detailData.custom_name}}</span>
            </el-form-item>
            <el-form-item label="客户电话:" >
              <span class="font16">{{detailData.custom_contact}}</span>
            </el-form-item>
            <el-form-item label="预估金额:">
              <span style="font-weight: bold;color: red;font-size: 20px">{{detailData.out_price}}</span>
            </el-form-item>
          </el-form>

        </div>
        <div style="height: 800px;overflow-y: auto;width: 60%" v-if="detailData.status == 0">
          <span style="font-weight: bold;font-size: 18px">结算订单:</span>
          <div style="display:flex;flex-direction: column;flex-wrap: wrap;margin-top: 20px" >
            <div style="margin: 2px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);padding:0 20px;height: 38px;display: flex;align-items: center" v-for="(item,index) in  SettleData.end_product">
              <div style="display: flex;align-items: center">
                <span class="font16" style="width: 300px;">{{item.category_name}} {{item.sku}}</span>
                <span class="font16" style="margin-left: 20px">出库数量：</span>
                <el-input-number v-model="item.recoveryNum" :min="0" size="mini" style="width: 120px;" :max="checkMaxFn(item)" @change="recoveryNumChangeFn($event,index)" label="描述文字"></el-input-number>
                <div style="display: flex;align-items: center" v-if="wornMaxFn(item)">
                  <span style="margin-left: 20px">出库异常数量：</span>
                  <el-input-number v-model="item.worn_two_num" :min="0" size="mini" style="width: 120px" :max="wornMaxFn(item)" label="描述文字"></el-input-number>
                </div>
                <span style="margin-left: 10px">出库单价：</span>
                <el-input v-model="item.end_unit_price" @input="unitPriceInput(index)" type="number" size="mini" :min="0" style="width: 100px" placeholder="请输入内容"></el-input>
                <span class="font16" style="margin-left: 10px">应结总价：</span>
                <el-input v-model="item.end_price" type="number" size="mini"  style="width: 100px" placeholder="请输入内容"></el-input>
              </div>
              <div style="display: flex;flex-direction: column" v-if="item.batch_list.length">
                <div v-for="(item1,index1) in item.batch_list" style="margin-top:10px;display: flex;align-items: center">
                  <span class="font16">批号：{{item1.batch_number}}</span>
                  <span class="font16" style="margin-left: 20px">批号数量：</span>
                  <el-input-number v-model="item1.batch_num" :min="0" size="mini" v-if="SettleData.is_fill!=1" @change="inputNumChangeFn($event,item1,index,index1)"  label="描述文字"></el-input-number>
                  <span class="font16" v-else>{{item1.batch_num}}</span>
                </div>
              </div>
            </div>
          </div>
          <el-form ref="form" label-width="100px" style="margin-top: 20px">
            <el-form-item label="应结总价:" label-width="100px" >
              <span style="font-size: 20px">{{priceAllFn}}</span>
            </el-form-item>
            <el-form-item label="已结总价:" label-width="100px" >
              <span style="font-size: 20px" class="font16">{{SettleData.real_price}}</span>
            </el-form-item>
            <div style="display: flex;align-items: center" >
              <el-form-item label="结算金额:" label-width="100px">
                <el-input size="mini" v-model="SettleForm.pay_money" style="width: 150px;"  placeholder="请输入内容"></el-input>
              </el-form-item>
              <el-form-item label="备注:" label-width="100px" >
                <!--              <span v-if="SettleData.status == 1">{{SettleData.end_remark}}</span>-->
                <el-input v-model="SettleForm.remark" style="width: 150px;" size="mini" placeholder="请输入内容"></el-input>
              </el-form-item>
            </div>
            <div style="padding:10px 30px 0;font-weight: bold;">结算记录</div>
            <div style="display: flex;align-items: center" v-for="(item,index) in SettleData.pay_list">
              <el-form-item label="结算金额:" label-width="100px" >{{item.payMoney}}</el-form-item>
              <el-form-item label="备注:" label-width="100px" >{{item.remark}}</el-form-item>
              <el-form-item label="结算时间:" label-width="100px" >{{item.times}}</el-form-item>
            </div>
          </el-form>
        </div>
        <div style="height: 800px;overflow-y: auto;width: 60%" v-else>
          <span style="font-weight: bold;font-size: 18px">结算详情:</span>
          <div style="display:flex;flex-direction: column;flex-wrap: wrap;margin-top: 20px" >
            <div style="display: flex;align-items:center;margin:2px 8px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);padding:0 20px;height: 38px" v-for="(item,index) in detailData.end_product">
              <div style="display: flex;align-items: center">
                <span style="width: 300px;">{{item.category_name}} {{item.sku}}</span>
                <div style="width: 150px;display: flex;align-items: center">
                  <span style="margin-left: 20px">结算数量：</span>
                  <span style="font-size: 18px;font-weight: bold;color: red">x{{item.recoveryNum}}</span>
                </div>
                <div style="width: 150px;display: flex;align-items: center">
                  <span style="margin-left: 20px">结算单价：</span>
                  <span style="font-size: 18px;font-weight: bold;color: red">{{item.end_unit_price}}</span>
                </div>
                <div style="width: 150px;display: flex;align-items: center" v-if="item.worn_two_num">
                  <span style="margin-left: 20px">异常数量：</span>
                  <span style="font-size: 18px;font-weight: bold;color: red">x{{item.worn_two_num?item.worn_two_num:'0'}}</span>
                </div>
                <span style="margin-left: 20px">应结总价：</span>
                <span style="font-size: 18px;font-weight: bold;color: red">{{item.end_price}}</span>
              </div>
              <div style="display: flex;flex-direction: column;margin-top: 10px" v-if="item.batch_list.length">
                <div v-for="(item1,index1) in item.batch_list" style="margin-bottom:20px;display: flex;align-items: center" v-if="item1.batch_num">
                  <span>批号：{{item1.batch_number}}</span>
                  <span style="margin-left: 20px">批号数量：</span>
                  <span style="font-size: 18px;font-weight: bold;color: red">x{{item1.batch_num}}</span>
                </div>
              </div>
            </div>
          </div>
          <el-form ref="form" label-width="100px" style="margin-top: 20px">
            <el-form-item label="结算备注:" label-width="100px" v-if="detailData.end_remark">
              <!--              <span v-if="SettleData.status == 1">{{SettleData.end_remark}}</span>-->
              <text>{{detailData.end_remark}}</text>
            </el-form-item>
            <el-form-item label="结算总价:" label-width="100px" label-size="medium">
              <!--              <span v-if="SettleData.status == 1">{{SettleData.end_remark}}</span>-->
              <span style="font-size: 18px;font-weight: bold;color: red">{{detailData.real_price}}</span>
            </el-form-item>
            <div style="padding:10px 30px 0;font-weight: bold;">结算记录</div>
            <div style="display: flex;align-items: center" v-for="(item,index) in SettleData.pay_list">
              <el-form-item label="结算金额:" label-width="100px" >{{item.payMoney}}</el-form-item>
              <el-form-item label="备注:" label-width="100px" >{{item.remark}}</el-form-item>
              <el-form-item label="结算时间:" label-width="100px" >{{item.times}}</el-form-item>
            </div>
          </el-form>

        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="expressFn">导出开单信息</el-button>
        <el-button @click="stashShow = false">{{SettleData.status == 1 ?'关 闭':'取 消'}}</el-button>
        <el-button type="primary" v-if="detailData.status == 0" @click="saveFn">未完结保存</el-button>
        <el-popconfirm
          confirm-button-text='好的'
          cancel-button-text='不用了'
          icon="el-icon-info"
          icon-color="red"
          @confirm="OrderUpdateFn"
          title="请确认应收金额已全部到账，当前出库单已全部完结"
          v-if="detailData.status == 0"
        >
           <el-button slot="reference" type="primary">确定完成</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // +----------------------------------------------------------------------
  // | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
  // +----------------------------------------------------------------------
  // | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
  // +----------------------------------------------------------------------
  // | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
  // +----------------------------------------------------------------------
  // | Author: CRMEB Team <admin@crmeb.com>
  // +----------------------------------------------------------------------
  import {
    recoveryStockCardListApi,
    stockSetUpdate,
    outStockOrderLst,
    outStockOrderDetail,
    customLst,
    outStockOrderSettlement,
    outStockOrderUpdate,
    outStockOrdercardList,
    outStockOrderEnd,
    outStockOrderDelete
  } from "@/api/recovery";
  import {roterPre} from "@/settings";
  import cardsData from "@/components/cards";
  import {fromList} from "@/libs/constants";
  import createWorkBook from "@/utils/newToExcel";
  export default {
    name: 'stashManage',
    components: {cardsData},
    computed:{
      remarkFn(){
        return function (v) {
          if(v){
            return v.split('^')
          }else{
            return []
          }

        }
      },
      checkMaxFn(){
        return function (item) {
          let indx = 0
            this.detailData.out_product.map((v,i)=>{
              if(v.recovery_attr_id == item.recovery_attr_id){
                console.log(v.recoveryNum)
                  indx = v.recoveryNum
              }
            })
          return indx
        }
      },
      /**
       * 计算结算总价格
       * */
      priceAllFn(){
        let nums = 0
        if(this.SettleData.is_fill==1){
          this.SettleData.end_product.map((item,index)=>{
            if(item.end_price){
              nums+= Number(item.end_price)
            }
          })
        }else{
          this.SettleData.out_product.map((item,index)=>{
            if(item.end_price){
              nums+= Number(item.end_price)
            }
          })
        }

        return nums
      },
      wornMaxFn(){
        return function (item) {
          let data = this.detailData.out_product
          for(let i = 0; data.length ; i++){
            if(data[i].recovery_attr_id == item.recovery_attr_id){
              return data[i].worn_two_num
            }
          }
          console.log('innnn')
          return 0
        }
      },
      maxFn(){
        return function (item,index) {
          let num = 0
          this.ruleForm.batch_list.map((item1,index1)=>{
            num+= item1.batch_num
          })
          return  this.ruleForm.stock - num + item.batch_num
        }
      }
    },

    data() {
      return {
        settleShow:false,// 控制结算订单弹框
        detailData:{},
        itemList:[],
        moren: require("@/assets/images/bjt.png"),
        isChecked: false,
        listLoading: true,
        deleteShow:false,
        tableData: {
          data: [],
          total: 0
        },
        clientList:[],
        statusList:[
          {
            statusTxt:'全部',
            status:''
          },
          {
            statusTxt:'待结算',
            status:0
          },
          {
            statusTxt:'已结算',
            status:1
          }
        ],
        clientValue:'',
        SettleData:{out_product:[]},// 结算订单数据
        ruleForm:{
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        },
        loadShow:false,
        roterPre: roterPre,
        rules:[],
        stashItem:{},
        stashShow:false,
        SettleForm:{
          remark:'',
          pay_money: ''
        },
        submitShow:false,
        tableFrom: {
          page: 1,
          limit: 20,
          custom_id:'',
          status:''
        },
        fromList: fromList,
        timeVal: [],
        dialogVisible:false,
        settType:'',
        cardLists: [],
        stockId:0,
        orderId:0,
      }
    },
    mounted() {
      this.getList()
      this.getClientListFn()
      setTimeout(()=>{
        this.expanded()
      },500)
    },
    methods: {
      saveFn(){
        this.settType = 'saveSettle'
        this.outStockOrderUpdateFn()
      },
      /**
       * 删除订单
       * */

      deleteShowFn(row){
        this.$alert('是否删除该订单', '删除订单', {
          confirmButtonText: '确定',
          callback: action => {
            if(action=='confirm'){
              if(row.status == 0){
                outStockOrderDetail(row.out_stock_order_id).then(res=> {
                  let data = res.data.detail
                  let params = {
                    end_product:data.is_fill ==1?data.end_product:data.out_product
                  }
                  params.end_product.map((v,i)=>{
                    v.worn_num = v.recoveryNum
                    v.recoveryNum = 0
                    v.worn_two_num = 0
                    v.end_price = 0
                  })
                  outStockOrderEnd(row.out_stock_order_id,params).then(res=>{
                    outStockOrderDelete(row.out_stock_order_id).then(res=>{
                      this.$message.success(res.message)
                      this.getList()
                    }).catch(res=>{
                      this.$message.error(res.message)
                    })
                  }).catch(err=>{
                    this.settType = ''
                    this.$message.error(err.message)
                  })
                })
              }else{
                 outStockOrderDelete(row.out_stock_order_id).then(res=>{
                      this.$message.success(res.message)
                      this.getList()
                    }).catch(res=>{
                      this.$message.error(res.message)
                    })
              }

            }
          }
        });
      },
      /**
       * 结算
       * */
      async submitFn(){
        if(!this.SettleForm.pay_money){
          this.stashShow = false
          this.$message.success('订单也确认')
          return
        }
        let params=this.SettleForm
        try{
          let res = await outStockOrderSettlement(this.orderId,params)
          if(this.settType == 'Settle'){
            this.settlementFn()
          }else{
            this.$message.success(res.message)
            // this.detailFn()
            this.stashShow = false
          }
          this.SettleForm={
            remark:'',
            pay_money: ''
          }
        } catch (err){
            this.settType = ''
            this.$message.error(err.message)
        }
      },
      /**
       * 获取客户列表
       * */
      getClientListFn(){
        customLst().then(res=>{
          res.data.list.unshift({custom_id:'',custom_name:'全部'})
          this.clientList = res.data.list
        })
      },
      /**
       * 获取结算订单详情
       * */
      stashFn(row){
        this.orderId= row.out_stock_order_id
        this.settType =''
          this.detailFn()
      },
      detailFn(){
        this.loadShow = true
        outStockOrderDetail(this.orderId).then(res=>{
          this.loadShow = false
          if(!res.data.detail.end_product){
            res.data.detail.end_product = []
          }
          for(let i = 0 ; i < res.data.detail.out_product.length ; i++){

            if(!res.data.detail.out_product[i].worn_two_num){
              res.data.detail.out_product[i].worn_two_num = 0
            }
            let indx = 'null'
            let obj = {}
            for(let j = 0 ; j < res.data.detail.end_product.length ; j++){
              if(res.data.detail.out_product[i].recovery_attr_id == res.data.detail.end_product[j].recovery_attr_id){
                if(res.data.detail.out_product[i].recoveryNum > res.data.detail.end_product[j].old_recoveryNum){ // 将新出库的数量加入已保存出库数量
                  let num = res.data.detail.out_product[i].recoveryNum - res.data.detail.end_product[j].old_recoveryNum // 合并数量
                  res.data.detail.end_product[j].recoveryNum = res.data.detail.end_product[j].recoveryNum + num // 将合并数量添加到结算订单
                  res.data.detail.end_product[j].old_worn_num = res.data.detail.end_product[j].old_worn_num + num // 将合并数量添同步添加到上一次出库数量
                }
                obj = JSON.parse(JSON.stringify(res.data.detail.end_product[j]))
                res.data.detail.end_product.splice(j,1)
                indx = j
              }
            }
            if(indx == 'null'){
              res.data.detail.end_product.splice(i,0,{...res.data.detail.out_product[i],...{old_worn_num:res.data.detail.out_product[i].recoveryNum}})
            }else{
              res.data.detail.end_product.splice(i,0,obj)
            }
          }
          // 处理结算总价计算
          res.data.detail.end_product.map((v,i)=>{
            v.end_price = v.recoveryNum* v.end_unit_price || 0
            if(!v.worn_two_num){
              v.worn_two_num = 0
            }
          })

          res.data.detail.out_product.map((v,i)=>{
            v.end_price = ''
          })
          this.detailData = res.data.detail // 出库订单详情
          this.SettleData = JSON.parse(JSON.stringify(res.data.detail))
          this.SettleData.end_product = JSON.parse(JSON.stringify(res.data.detail)).end_product // 结算订单详情
          console.log(this.SettleData)
          console.log(this.SettleData.end_product,this.detailData)
          this.SettleForm={
            remark:'',
            pay_money: ''
          }
        this.$forceUpdate()
          if(!this.settType){
            this.stashShow = true
          }
        }).catch((err)=>{
          this.loadShow = false
        })
      },
      // 结算信息导出
      expressFn(){
        console.log(this.SettleData.end_product)
        let lebData = {
          title:['出库订单'],
          header:['商品名称','数量','单价','总价'],
          filename:'结算记录_'+this.getTimeFn(),
          export:[],
          foot:[]
        }
        let nums = 0
        let price = 0
        this.SettleData.end_product.map((v,i)=>{
          console.log(v)
          let obj = []
          nums+= Number(v.recoveryNum)
          price += Number(v.end_price)
          obj[0] = v.category_name + v.sku
          obj[1] = v.recoveryNum
          obj[2] = v.end_unit_price
          obj[3] = v.end_price
          lebData.export.push(obj)
        })
        lebData.export.push(['合计',nums,'',price])
        lebData.foot.push('开单时间：'+this.detailData.create_time)
        console.log(lebData)
        createWorkBook(lebData.header, lebData.title, lebData.export, lebData.foot,lebData.filename);
      },
      getTimeFn(){
        let date = new Date()
        let y = date.getFullYear()
        let m = (date.getMonth() + 1)>9?date.getMonth() + 1:'0'+date.getMonth() + 1
        let d = date.getDate()>9?date.getDate():'0'+date.getDate()
        let h = date.getHours()>9?date.getHours():'0'+date.getHours()
        let min = date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes()
        let s = date.getSeconds()
        return y+''+m+d+h+min+s
      },
      // 出库数量 进行编辑 减少多少个或者增加多少个
      recoveryNumChangeFn(e,index){
        let num = 0
        this.detailData.end_product.map((v,i)=>{
          if(v.recovery_attr_id == this.SettleData.end_product[index].recovery_attr_id){
            num = v.old_worn_num - e
          }
        })
        let procuct =  this.SettleData.end_product[index]
        procuct.worn_num = num
         procuct.end_price =  Number(procuct.recoveryNum) * Number(procuct.end_unit_price)
      },
      /**
       * 结算订单修改批号
       * */
      inputNumChangeFn(e,item,index,index1){
        if(!this.SettleData.out_product[index].worn_batch_list){
          this.SettleData.out_product[index].worn_batch_list = []
        }
       if(this.detailData.out_product[index].batch_list[index1].batch_num - e >0){ // 当结算批号数量减少时 将减少数量及批号名添加进worn_batch_list
         let indx = 'null'
         this.SettleData.out_product[index].worn_batch_list.some((v,i)=>{
           if(v.batch_number == item.batch_number){
             indx = i
             return true
           }
         })
         if(indx != 'null'){
           if(this.detailData.out_product[index].batch_list[index1].batch_num - e == 0){
             this.SettleData.out_product[index].worn_batch_list.splice(indx,1)
           }else{
             this.SettleData.out_product[index].worn_batch_list[indx].worn_batch_num = this.detailData.out_product[index].batch_list[index1].batch_num - e
           }
         }else{
           this.SettleData.out_product[index].worn_batch_list.push({
             worn_batch_num:this.detailData.out_product[index].batch_list[index1].batch_num - e,
             batch_number: this.SettleData.out_product[index].batch_list[index1].batch_number
           })
         }
       }else{  // 当结算批号数量增加时
         let indx = 'null'
         this.SettleData.out_product[index].worn_batch_list.some((v,i)=>{
           if(v.batch_number == item.batch_number){
             indx = i
             return true
           }
         })
         if(indx != 'null'){
           if(this.detailData.out_product[index].batch_list[index1].batch_num - e == 0){
             this.SettleData.out_product[index].worn_batch_list.splice(indx,1)
           }else{
             this.SettleData.out_product[index].worn_batch_list[indx].worn_batch_num = this.detailData.out_product[index].batch_list[index1].batch_num - e
           }
         }else{
           this.SettleData.out_product[index].worn_batch_list.push({
             worn_batch_num:this.detailData.out_product[index].batch_list[index1].batch_num - e,
             batch_number: this.SettleData.out_product[index].batch_list[index1].batch_number
           })
         }
       }
      },
      stashClose(){
        this.stashShow = false
      },
      unitPriceInput(index){
        let data = this.SettleData.end_product[index]
        data.end_price = data.end_unit_price * data.recoveryNum
      },
      // 确认提交
      OrderUpdateFn(){
        // 判断结算金额是否填写
        if(!this.SettleForm.pay_money){
          this.settlementFn() // 直接调用完成结算接口
        }else{
          this.settType = 'Settle'
          this.submitFn() // 调用保存接口 跟着调用完成结算接口
        }
      },
      /**
       * 结算完成
       * */
      settlementFn(){
        let params = {end_product: this.SettleData.end_product}
        params.end_product.map((item,index)=>{
          if(!item.worn_batch_list){
            item.worn_batch_list = []
          }
          if(!item.worn_num){
            item.worn_num = 0
          }
          if(item.end_price){
            return true
          }else{
            item.end_price = 0
          }
        })
        outStockOrderEnd(this.orderId,params).then(res=>{
          this.$message.success(res.message)
          this.getList()
          this.stashShow=false
          this.settType = ''
        }).catch(err=>{
          this.settType = ''
          this.$message.error(err.message)
        })
      },
      /**
       * 出库结算
       * */
      async outStockOrderUpdateFn(){
        if(this.submitShow)return
        let params = {
          end_product:this.SettleData.end_product
        }
        params.end_product.map((item,index)=>{
          if(!item.worn_batch_list){
            item.worn_batch_list = []
          }
          item.old_worn_num = item.recoveryNum // 当前出库数量进行保存
          this.detailData.out_product.map((v,i)=>{
            if(v.recovery_attr_id == item.recovery_attr_id){
                item.old_recoveryNum = v.recoveryNum // 提交保存上一次出库数量 用与处理合并值
            }
          })
          if(!item.worn_num){
            item.worn_num = 0
          }
          item.end_price = 0
        })
        this.submitShow= true
        try {
          let data = await outStockOrderUpdate(this.SettleData.out_stock_order_id,params)
          if(this.settType =='Settle' || this.settType=='saveSettle'){
            this.submitFn()
          }else{
            this.$message.success(data.message)
            this.stashShow = false
            this.getList()
          }
          this.submitShow= false
        } catch (e) {
          this.settType = ''
          this.$message.error(e.message)
          this.submitShow= false
        }

      },
      /**
       * 修改库存
       */
      async batchConfirm(){
        /**
         * 判断批号是否输入完整
         * */
        if(this.ruleForm.batch_list.some((v,i)=>{if(!v.batch_number)return true}))
        {
          this.$message.error('请检查批号是否输入完整')
          return
        }
        if(this.ruleForm.type == 0){ // 减少库存的时候必传出库价格
          if(!this.ruleForm.outbound_price){
            this.$message.error('请输入出库价格')
            return
          }
        }

        let data = await stockSetUpdate(this.stockId,this.ruleForm)
        this.getList()
        this.handleClose()
      },
      handleClose(){
        this.dialogVisible = false
      },
      batchChange(e,index){
        if(e<=0){
          this.$nextTick(()=>{
            this.ruleForm.batch_list.splice(index,1)
          })
        }
      },
      /**
       * 立即出库
       */
      stashConfirmFn(){

      },
      expanded(){
        const els = document.getElementsByClassName('el-table__expand-icon');
        this.$nextTick(()=>{
          els[0].click()
        })
      },
      /**
       * 增加批号
       * */
      addBatchFn(){
        let num = 0
        this.ruleForm.batch_list.map((item,index)=>{
          num+= item.batch_num
        })
        if(num < this.ruleForm.stock){
          this.ruleForm.batch_list.push({batch_number:'',batch_num: 1})
        }

      },
      /**
       * 获取列表
       */
      getList() {
        this.listLoading = true
        console.log(this.tableFrom)
        outStockOrderLst(this.tableFrom).then(res => {
          this.tableData.data = res.data.list
          this.tableFrom.total = res.data.count
          this.listLoading = false
          this.getCardList()
        }).catch(res => {
          this.listLoading = false
          this.$message.error(res.message)
        })
      },
      pageChange(page) {
        console.log(page)
        this.tableFrom.page = page
        this.getList()
      },
      handleSizeChange(val) {
        this.tableFrom.limit = val
        this.getList()
      },
      // 选择时间
      selectChange(tab) {
        this.tableFrom.date = tab;
        this.tableFrom.page = 1;
        this.timeVal = [];
        this.getList(1);
      },
      // 具体日期
      onchangeTime(e) {
        this.timeVal = e;
        this.tableFrom.date = e ? this.timeVal.join("-") : "";
        this.tableFrom.page = 1;
        this.getList(1);
      },
      // 设置库存
      setRecoveryStock(row) {
        this.dialogVisible = true
        this.stockId = row.recovery_stock_id
        this.ruleForm={
          outbound_price:'',
          type:1,
          stock:1,
          batch_list:[],
        }
        // this.$modalForm(setRecoveryStockFormApi(row.recovery_stock_id)).then(() => this.getList(''))
      },
      getCardList(){
        outStockOrdercardList(this.tableFrom)
          .then((res) => {
            this.cardLists = res.data;
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      },
    }
  }
</script>

<style scoped lang="scss">
  .detail{
    /deep/.el-form-item{
      margin: 0;
    }
  }
  .font16{
    font-size: 13px;
  }
</style>
